/**
 * ToolPrimer — editorial "how this tool works" primer, used at the bottom of every
 * financial tool page. Kept intentionally quiet to sit beneath the calculator UI:
 * two typographic columns, one small caveat block, no decoration.
 */
export default function ToolPrimer({ eyebrow = "How to read this tool", title, sections = [], caveat }) {
  return (
    <section
      data-testid="tool-primer"
      className="mt-16 md:mt-24 border-t border-border pt-10 md:pt-14 no-print"
    >
      <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12">
        <div className="md:col-span-4">
          <div className="text-[10px] uppercase tracking-[0.3em] text-foreground/60 mb-4">
            {eyebrow}
          </div>
          <h2 className="font-serif text-3xl md:text-4xl font-light leading-[1.05] tracking-tighter">
            {title}
          </h2>
        </div>
        <div className="md:col-span-8 space-y-8 text-[15px] leading-[1.75] text-foreground/80">
          {sections.map((s, i) => (
            <div key={s.heading || `primer-${i}`}>
              {s.heading && (
                <div className="text-[10px] uppercase tracking-[0.25em] text-primary mb-2">
                  {s.heading}
                </div>
              )}
              <p className="text-foreground/80">{s.body}</p>
            </div>
          ))}
          {caveat && (
            <div className="mt-8 border-l-2 border-accent/60 pl-5 italic text-foreground/60 text-[14px] leading-relaxed">
              {caveat}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
